import {convertRowsToData} from '../utils/dataUtils'

export default function ScatterDataController (rows) {
  
  let headers = rows[0]
  let propperHeaders = ['id','x','y','group','size']
  let data = convertRowsToData([propperHeaders,...rows.slice(1)],4)
  
  return data.map((point)=>{
    return {
      id: point.id,
      x: +point.value.find((d)=>d.id==='x').value,
      y: +point.value.find((d)=>d.id==='y').value,
      group: point.value.find((d)=>d.id==='group').value,
      size: +point.value.find((d)=>d.id==='size').value
    }
  })
}